import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "setting-table-row border" }
const _hoisted_4 = { class: "setting-cell cell-label setting" }
const _hoisted_5 = { class: "setting-texts" }
const _hoisted_6 = { class: "setting-cell cell-label calc" }
const _hoisted_7 = { class: "setting-texts" }
const _hoisted_8 = { class: "setting-table-row border" }
const _hoisted_9 = { class: "setting-cell cell-label setting" }
const _hoisted_10 = { class: "setting-texts" }
const _hoisted_11 = { class: "setting-cell cell-label calc" }
const _hoisted_12 = { class: "setting-texts" }
const _hoisted_13 = { class: "setting-table-row border" }
const _hoisted_14 = { class: "setting-cell cell-label setting" }
const _hoisted_15 = { class: "setting-texts" }
const _hoisted_16 = { class: "setting-cell cell-label calc" }
const _hoisted_17 = { class: "setting-texts" }
const _hoisted_18 = { class: "setting-table-row border" }
const _hoisted_19 = { class: "setting-cell cell-label setting" }
const _hoisted_20 = { class: "setting-texts" }
const _hoisted_21 = { class: "setting-cell cell-label calc" }
const _hoisted_22 = { class: "setting-texts" }
const _hoisted_23 = { class: "setting-table-row border" }
const _hoisted_24 = { class: "setting-cell cell-label setting" }
const _hoisted_25 = { class: "setting-texts" }
const _hoisted_26 = { class: "setting-cell cell-label calc" }
const _hoisted_27 = { class: "setting-texts" }
const _hoisted_28 = { class: "per-age-round-row" }
const _hoisted_29 = { class: "per-age-round-row-cell" }
const _hoisted_30 = { class: "setting-texts" }
const _hoisted_31 = { class: "setting-texts bold mb-4" }
const _hoisted_32 = { class: "per-age-round-row" }
const _hoisted_33 = { class: "per-age-round-row-cell" }
const _hoisted_34 = { class: "setting-texts" }
const _hoisted_35 = { class: "per-age-round-row-cell" }
const _hoisted_36 = { class: "setting-texts" }
const _hoisted_37 = { style: {"width":"300px"} }
const _hoisted_38 = { style: {"width":"300px"} }
const _hoisted_39 = {
  class: "per-age-round-row",
  style: {"gap":"1rem"}
}
const _hoisted_40 = { style: {"width":"240px"} }
const _hoisted_41 = { class: "d-flex mt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.placementSetting)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[46] || (_cache[46] = _createStaticVNode("<h2 class=\"mb-2\" data-v-7deadb9c>① 園児 年齢ごとの設定</h2><div class=\"setting-table-row\" data-v-7deadb9c><div class=\"header cell-label age\" data-v-7deadb9c>年齢</div><div class=\"header cell-label setting\" data-v-7deadb9c>設定</div><div class=\"header cell-label calc\" data-v-7deadb9c>算式</div></div>", 2)),
            _createElementVNode("div", _hoisted_3, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "setting-cell cell-label age" }, [
                _createElementVNode("div", { class: "setting-texts" }, "0歳児")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[17] || (_cache[17] = _createTextVNode(" 保育士 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age0,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.placementSetting.perChildren.age0) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[18] || (_cache[18] = _createTextVNode(" 名につき、園児 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age0,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.placementSetting.perStaff.age0) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[19] || (_cache[19] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, " 園児数 × " + _toDisplayString(_ctx.placementSetting.perChildren.age0) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age0), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "setting-cell cell-label age" }, [
                _createElementVNode("div", { class: "setting-texts" }, "1歳児")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[21] || (_cache[21] = _createTextVNode(" 保育士 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.placementSetting.perChildren.age1) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[22] || (_cache[22] = _createTextVNode(" 名につき、園児 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age1,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.placementSetting.perStaff.age1) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[23] || (_cache[23] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, " 園児数 × " + _toDisplayString(_ctx.placementSetting.perChildren.age1) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age1), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "setting-cell cell-label age" }, [
                _createElementVNode("div", { class: "setting-texts" }, "2歳児")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[25] || (_cache[25] = _createTextVNode(" 保育士 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age2,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.placementSetting.perChildren.age2) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[26] || (_cache[26] = _createTextVNode(" 名につき、園児 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age2,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.placementSetting.perStaff.age2) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[27] || (_cache[27] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, " 園児数 × " + _toDisplayString(_ctx.placementSetting.perChildren.age2) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age2), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "setting-cell cell-label age" }, [
                _createElementVNode("div", { class: "setting-texts" }, "3歳児")
              ], -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[29] || (_cache[29] = _createTextVNode(" 保育士 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age3,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.placementSetting.perChildren.age3) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[30] || (_cache[30] = _createTextVNode(" 名につき、園児 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age3,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.placementSetting.perStaff.age3) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[31] || (_cache[31] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, " 園児数 × " + _toDisplayString(_ctx.placementSetting.perChildren.age3) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age3), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "setting-cell cell-label age" }, [
                _createElementVNode("div", { class: "setting-texts" }, "4歳児以上")
              ], -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[33] || (_cache[33] = _createTextVNode(" 保育士 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.perChildren.age4,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.placementSetting.perChildren.age4) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[34] || (_cache[34] = _createTextVNode(" 名につき、園児 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.perStaff.age4,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.placementSetting.perStaff.age4) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[35] || (_cache[35] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, " 園児数 × " + _toDisplayString(_ctx.placementSetting.perChildren.age4) + " / " + _toDisplayString(_ctx.placementSetting.perStaff.age4), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "per-age-round-row-header" }, [
                _createElementVNode("div", { class: "setting-texts" }, "年齢ごとの共通計算設定")
              ], -1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[37] || (_cache[37] = _createTextVNode(" 小数点 ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"160px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.roundingPerAge.decimalPlaces,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.placementSetting.roundingPerAge.decimalPlaces) = $event)),
                      items: [
                    { value: 1, title: '第一位' },
                    { value: 2, title: '第二位' },
                  ],
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[38] || (_cache[38] = _createTextVNode(" を ", -1)),
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"160px"},
                      class: "mx-2",
                      modelValue: _ctx.placementSetting.roundingPerAge.action,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.placementSetting.roundingPerAge.action) = $event)),
                      items: [
                    { value: 'down', title: '切り捨て' },
                    { value: 'normal', title: '四捨五入' },
                    { value: 'up', title: '切り上げ' },
                  ],
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _cache[47] || (_cache[47] = _createElementVNode("h2", { class: "mb-2 mt-16" }, "② 合算", -1)),
            _createElementVNode("div", _hoisted_31, [
              _cache[40] || (_cache[40] = _createTextVNode(" ①で求めた値の小数点第一位を ", -1)),
              _createElementVNode("span", null, [
                _createVNode(_component_v_select, {
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  style: {"width":"160px"},
                  class: "mx-2",
                  modelValue: _ctx.placementSetting.roundingAll.action,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.placementSetting.roundingAll.action) = $event)),
                  items: [
                { value: 'down', title: '切り捨て' },
                { value: 'normal', title: '四捨五入' },
                { value: 'up', title: '切り上げ' },
              ],
                  color: "primary"
                }, null, 8, ["modelValue"])
              ]),
              _cache[41] || (_cache[41] = _createTextVNode(" + {自治体加配 (③) + 配慮が必要な園児への保育者加配} = 必要保育配置者数 ", -1))
            ]),
            _cache[48] || (_cache[48] = _createElementVNode("p", { class: "setting-texts" }, "* 必要配置保育者数が2名未満の場合は、必要配置保育者数は2名になります。", -1)),
            _cache[49] || (_cache[49] = _createElementVNode("h2", { class: "mb-2 mt-16" }, "③ 自治体加配", -1)),
            _createElementVNode("div", _hoisted_32, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "per-age-round-row-header" }, [
                _createElementVNode("div", { class: "setting-texts" }, "自治体加配")
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"60px"},
                      class: "mx-2",
                      type: "number",
                      modelValue: _ctx.placementSetting.additional.staffCount,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.placementSetting.additional.staffCount) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[42] || (_cache[42] = _createTextVNode(" 名 ", -1))
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "per-age-round-row-header" }, [
                _createElementVNode("div", { class: "setting-texts" }, "範囲")
              ], -1)),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_hour_minute_input, {
                      modelValue: _ctx.placementSetting.additional.startMin,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.placementSetting.additional.startMin) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("span", {
                    class: "mx-2",
                    style: {"width":"40px"}
                  }, "から", -1)),
                  _createElementVNode("span", _hoisted_38, [
                    _createVNode(_component_hour_minute_input, {
                      modelValue: _ctx.placementSetting.additional.endMin,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.placementSetting.additional.endMin) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _cache[52] || (_cache[52] = _createElementVNode("h2", { class: "mb-2 mt-16" }, "④ 配慮が必要な園児のために雇う方の時給", -1)),
          _createElementVNode("div", _hoisted_39, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "per-age-round-row-header" }, [
              _createElementVNode("div", { class: "setting-texts" }, "時給")
            ], -1)),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_v_text_field, {
                density: "compact",
                "hide-details": "",
                variant: "outlined",
                suffix: "円",
                modelValue: _ctx.placementSetting.subsidyChildcare.hourlyWageAmount,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.placementSetting.subsidyChildcare.hourlyWageAmount) = $event)),
                type: "number",
                color: "primary"
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.isUpdating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                class: "my-2",
                indeterminate: "",
                color: "primary"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              size: "large",
              variant: "flat",
              color: "primary",
              onClick: _ctx.updatePlacementSetting
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createTextVNode("保存", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_spacer)
          ])
        ], 64))
  ]))
}